module.exports = __webpack_public_path__ + "img/201601-2.da93fde7.jpg";